import {
  Backdrop,
  Box,
  CircularProgress,
  styled,
  useTheme,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import React from "react";

const TableComponent = ({ columns, data, sortModel, ...props }) => {
  const theme = useTheme();

  function generateRandom() {
    var length = 8,
      charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "end",
        }}
      >
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    fontSize: "0.85rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.75rem",
    },
    "& .MuiDataGrid-columnHeader": {
      height: "unset !important",
      maxHeight: "100% !important",
    },
    "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
      // borderBottom: `1px solid #87898aff`,
    },
    "& .MuiDataGrid-root, .MuiDataGrid-row": {
      "&:nth-of-type(2n)": {
        backgroundColor: grey[200],
      },
      maxHeight: "none !important",
      height: "auto !important",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      whiteSpace: "normal",
      lineHeight: "normal",
    },
    "& .MuiDataGrid-cell": {
      whiteSpace: "normal !important",
      wordWrap: "break-word !important",
      lineHeight: "1.5 !important",
      padding: "8px !important",
      display: "flex !important",
      alignItems: "center !important",
    },
  }));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 300px)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.06)",
        overflow: "hidden",
      }}
    >
      <StyledDataGrid
        pagination
        sx={{ flex: 1 }}
        rows={data}
        columns={columns}
        loading={props.loading}
        getRowId={(row) => generateRandom()}
        getRowHeight={() => "auto"}
        components={{
          Toolbar: CustomToolbar,
          LoadingOverlay: CircularProgress,
          // }}
          // slots={{
          // loadingOverlay: (
          //   <Backdrop
          //     sx={{
          //       color: theme.palette.background.default,
          //       zIndex: (theme) => theme.zIndex.drawer + 1,
          //     }}
          //     open={props.loading}
          //   >
          //     <CircularProgress color="inherit" />
          //   </Backdrop>
          // ),
        }}
        sortingOrder={["desc", "asc"]}
        initialState={{
          sorting: {
            sortModel: sortModel,
          },
        }}
        {...props}
      />
    </Box>
  );
};

export default TableComponent;
